<template>
  <div class="login-view">
    <div class="logo-wrapper">
      <Logo :showText="true" :isAuthLogo="true" />
    </div>
    
    <h1 class="auth-title">Welcome to the<br>Expert Panel Tool</h1>
    
    <div class="auth-card">
      <div class="auth-tabs">
        <div class="auth-tab active">LOGIN</div>
        <div class="auth-tab" @click="goToRegister">REGISTER</div>
      </div>
      
      <div class="auth-form">
        <form @submit.prevent="login">
          <div class="form-group">
            <input 
              type="text" 
              class="form-control" 
              placeholder="Your Name" 
              v-model="credentials.username" 
              required
            >
          </div>
          
          <div class="form-group">
            <input 
              type="password" 
              class="form-control" 
              placeholder="Password" 
              v-model="credentials.password" 
              required
            >
          </div>
          
          <div class="form-group remember-me">
            <label class="checkbox-container">
              <input type="checkbox" v-model="rememberMe">
              <span class="checkbox-custom"></span>
              Remember username
            </label>
          </div>
          
          <button type="submit" class="btn btn-primary btn-block" :disabled="loading">
            {{ loading ? 'Logging in...' : 'Log In' }}
          </button>
          
          <div class="error-message" v-if="error">{{ error }}</div>
          
          <div class="auth-links">
            <router-link to="/forgot-password" class="forgot-password-link">Forgot Password?</router-link>
          </div>
        </form>
      </div>
    </div>
    
    <footer class="auth-footer">
      <div>© {{ currentYear }} Top Line Marketing. All Rights Reserved.</div>
      <div><!-- <a href="#" @click.prevent="showPrivacyPolicy">Privacy Policy</a> --></div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Logo from '@/components/Logo.vue'

export default {
  name: 'LoginView',
  components: {
    Logo
  },
  data() {
    return {
      credentials: {
        username: '',
        password: ''
      },
      rememberMe: false
    }
  },
  computed: {
    ...mapState(['loading', 'error']),
    currentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    async login() {
      try {
        // The store and auth.js will handle token management properly now
        
        // Let the store handle the login and token storage
        await this.$store.dispatch('login', this.credentials);
        console.log('Login successful');
        
        this.$router.push({ name: 'home' });
      } catch (error) {
        // Error is handled by the store
        console.error('Login failed');
      }
    },
    goToRegister() {
      this.$router.push({ name: 'register' });
    }
  }
}
</script>

<style scoped>
.login-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 20px;
}

.logo-wrapper {
  margin-bottom: 20px;
}

.auth-title {
  font-size: 28px;
  font-weight: bold;
  margin: 30px 0;
  text-align: center;
  line-height: 1.3;
}

.auth-card {
  background-color: white;
  border-radius: 8px;
  width: 100%;
  max-width: 450px;
  overflow: hidden;
}

.auth-tabs {
  display: flex;
}

.auth-tab {
  flex: 1;
  padding: 15px;
  text-align: center;
  cursor: pointer;
  background-color: #f1f5f9;
  color: #333;
  font-weight: bold;
}

.auth-tab.active {
  background-color: white;
}

.auth-form {
  padding: 30px;
  color: #333;
}

.form-group {
  margin-bottom: 20px;
}

.form-control {
  display: block;
  width: 100%;
  padding: 12px 15px;
  font-size: 16px;
  line-height: 1.5;
  color: #495057;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus {
  border-color: #4A6282;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(74, 98, 130, 0.25);
}

.btn {
  display: inline-block;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  padding: 12px 15px;
  font-size: 16px;
  line-height: 1.5;
  border-radius: 4px;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  width: 100%;
}

.btn-primary {
  color: #fff;
  background-color: #4A6282;
  border-color: #4A6282;
}

.btn-primary:hover {
  background-color: #3d5270;
  border-color: #395069;
}

.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.remember-me {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.checkbox-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  user-select: none;
}

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-custom {
  height: 20px;
  width: 20px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
}

.checkbox-container input:checked ~ .checkbox-custom:after {
  content: "";
  position: absolute;
  display: block;
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid #4A6282;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.error-message {
  color: #e94057;
  margin-top: 10px;
  font-size: 14px;
  text-align: center;
}

.auth-links {
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
}

.forgot-password-link {
  color: #4A6282;
  text-decoration: none;
}

.forgot-password-link:hover {
  text-decoration: underline;
}

.auth-footer {
  margin-top: 30px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.auth-footer a {
  color: white;
  text-decoration: none;
}

.auth-footer a:hover {
  text-decoration: underline;
}
</style> 